import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import PlusSmIcon from '@heroicons/react/solid/PlusSmIcon';
import {nanoid} from 'nanoid/non-secure';

InlineAddBlockButton.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    index: PropTypes.number,
    onClick: PropTypes.func,
};

InlineAddBlockButton.defaultProps = {
    onClick: () => {},
};

function InlineAddBlockButton({className, label, index, onClick}) {
    const dispatchAdd = (component) => {
        document.dispatchEvent(
            new CustomEvent('cx:on-component-add', {
                bubbles: true,
                cancelable: true,
                detail: {component, index},
            })
        );
    };

    const addPlaceholder = () =>
        dispatchAdd({id: nanoid(), type: 'placeholder-block', placeholder: true, values: {}});

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (onClick) onClick();
        else addPlaceholder();
    };

    const rootClass = classNames(
        'w-full h-6 absolute z-10',
        className
    );

    return (
        <div className={rootClass}>
            <div className="relative flex h-full items-center justify-center">
                <button
                    type="button"
                    aria-label={label}
                    onClick={handleClick}
                    className="relative inline-flex h-6 w-6 items-center justify-center rounded-full text-white focus:outline-none focus:ring-2 focus:ring-offset-2"
                    style={{
                        background:
                            'linear-gradient(90deg, rgba(79,79,229,1) 0%, rgba(0,255,252,1) 51%, rgba(79,79,229,1) 100%)',
                        animation: 'animatedgradient 9s cubic-bezier(.68, .9, .48, .21) alternate infinite',
                        backgroundSize: '800% 800%',
                    }}
                >
                    <PlusSmIcon className="h-6 w-6" aria-hidden="true"/>
                </button>
            </div>
        </div>
    );
}

export default InlineAddBlockButton;
